import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=8a54e678&"
import script from "./layout.vue?vue&type=script&lang=ts&"
export * from "./layout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zfh/dev/targus-micor/targus-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a54e678')) {
      api.createRecord('8a54e678', component.options)
    } else {
      api.reload('8a54e678', component.options)
    }
    module.hot.accept("./layout.vue?vue&type=template&id=8a54e678&", function () {
      api.rerender('8a54e678', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout.vue"
export default component.exports